import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import ForgotPassword from './ForgotPassword';

const LOGO = 'https://botanix.in/wp-content/uploads/2025/12/Botanix-Nature-Resort-Logo.webp';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#162A40',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#22C55E', accentDark:'#16A34A',
 red:'#EF4444', redBg:'rgba(239,68,68,.10)', redBorder:'rgba(239,68,68,.25)',
 amber:'#F59E0B',
};

const QUICK_LOGINS = [
 { label:'Super Admin', email:'atul@botanix.in', pass:'Admin@123', color:'#E91E63' },
 { label:'GM', email:'gm@botanix.in', pass:'GM@12345', color:'#22C55E' },
 { label:'Sales', email:'mena@botanix.in', pass:'Sales@123', color:'#3B82F6' },
 { label:'Front Office', email:'frontoffice@botanix.in', pass:'FO@12345', color:'#F59E0B' },
 { label:'Kitchen', email:'kitchen@botanix.in', pass:'Kitchen@123',color:'#F97316' },
 { label:'Housekeeping', email:'housekeeping@botanix.in', pass:'HK@12345', color:'#8B5CF6' },
 { label:'Accounts', email:'gautam@botanix.in', pass:'Accts@123', color:'#06B6D4' },
];

export default function LoginPage() {
 const { login } = useAuth();
 const [showForgot, setShowForgot] = useState(false);
 const [email, setEmail] = useState('');
 const [password, setPassword] = useState('');
 const [error, setError] = useState('');
 const [loading, setLoading] = useState(false);
 const [showPass, setShowPass] = useState(false);
 const [showQuick, setShowQuick] = useState(false);

 if (showForgot) return <ForgotPassword onBack={()=>setShowForgot(false)} />;

 const handleLogin = async () => {
 if (!email) { setError('Enter your email address'); return; }
 if (!password) { setError('Enter your password'); return; }
 setLoading(true); setError('');
 try {
 const result = await login(email, password);
 if (!result?.success) throw new Error(result?.error || 'Invalid credentials');
 } catch(e) { setError(e.message); }
 finally { setLoading(false); }
 };

 const fillQuick = (q) => {
 setEmail(q.email);
 setPassword(q.pass);
 setShowQuick(false);
 setError('');
 };

 const inp = {
 width:'100%', padding:'13px 16px',
 background:'rgba(255,255,255,.06)',
 border:`1.5px solid ${C.border2}`,
 borderRadius:10, color:C.text, fontSize:14,
 fontFamily:'Inter,sans-serif', boxSizing:'border-box',
 outline:'none',
 };

 return (
 <div style={{ minHeight:'100vh', background:C.bg, display:'flex', fontFamily:'Inter,sans-serif', overflow:'hidden' }}>

 {/* Left Panel — Branding */}
 <div style={{ flex:1, display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', padding:48,
 background:'linear-gradient(135deg, #060E1C 0%, #0A1628 50%, #0F2040 100%)',
 borderRight:`1px solid ${C.border}`, position:'relative', overflow:'hidden' }}>

 {/* Background decoration */}
 <div style={{ position:'absolute', top:-100, right:-100, width:400, height:400, borderRadius:'50%', background:'rgba(34,197,94,.03)', border:'1px solid rgba(34,197,94,.08)' }} />
 <div style={{ position:'absolute', bottom:-150, left:-100, width:500, height:500, borderRadius:'50%', background:'rgba(34,197,94,.02)', border:'1px solid rgba(34,197,94,.05)' }} />

 <div style={{ position:'relative', textAlign:'center', maxWidth:400 }}>
 <img src={LOGO} alt="Botanix" style={{ height:90, objectFit:'contain', marginBottom:28 }}
 onError={e=>e.target.style.display='none'} />

 <div style={{ fontSize:28, fontWeight:900, color:'#F0F2FF', marginBottom:8, letterSpacing:'-.02em' }}>
 Botanix Nature Resort
 </div>
 <div style={{ fontSize:16, color:C.accent, fontWeight:600, marginBottom:6 }}>
 Enterprise Resource Planning
 </div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:40, lineHeight:1.7 }}>
 Village Damdama, Tehsil Sohna<br/>Gurgaon-122102, Haryana, India
 </div>

 {/* Feature pills */}
 <div style={{ display:'flex', flexWrap:'wrap', gap:8, justifyContent:'center' }}>
 {[' Bookings',' Accounts',' Front Office',' Housekeeping',' Kitchen',' Inventory',' Dynamic Pricing',' AI Analytics'].map(f=>(
 <span key={f} style={{ padding:'5px 12px', background:'rgba(34,197,94,.1)', border:'1px solid rgba(34,197,94,.2)', borderRadius:20, fontSize:11, color:C.accent, fontWeight:600 }}>{f}</span>
 ))}
 </div>

 <div style={{ marginTop:40, padding:16, background:'rgba(255,255,255,.04)', border:`1px solid ${C.border}`, borderRadius:12 }}>
 <div style={{ fontSize:11, color:C.text3, marginBottom:4 }}>CONTACT</div>
 <div style={{ fontSize:12, color:C.text2 }}> +91-9211445430 · info@botanix.in</div>
 </div>
 </div>
 </div>

 {/* Right Panel — Login Form */}
 <div style={{ width:440, display:'flex', flexDirection:'column', justifyContent:'center', padding:'48px 40px', background:C.bg }}>

 <div style={{ marginBottom:32 }}>
 <div style={{ fontSize:24, fontWeight:900, color:C.text, marginBottom:6 }}>Welcome Back</div>
 <div style={{ fontSize:13, color:C.text2 }}>Sign in to your Botanix ERP account</div>
 </div>

 {error && (
 <div style={{ padding:'12px 14px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:10, color:C.red, fontSize:13, marginBottom:20, display:'flex', alignItems:'center', gap:8 }}>
 {error}
 </div>
 )}

 {/* Email */}
 <div style={{ marginBottom:16 }}>
 <label style={{ display:'block', fontSize:11, fontWeight:700, color:C.text2, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:7 }}>Email Address</label>
 <input style={inp} type="email" value={email}
 onChange={e=>{ setEmail(e.target.value); setError(''); }}
 onKeyDown={e=>e.key==='Enter'&&handleLogin()}
 placeholder="you@botanix.in" autoFocus />
 </div>

 {/* Password */}
 <div style={{ marginBottom:8 }}>
 <label style={{ display:'block', fontSize:11, fontWeight:700, color:C.text2, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:7 }}>Password</label>
 <div style={{ position:'relative' }}>
 <input style={{ ...inp, paddingRight:48 }} type={showPass?'text':'password'} value={password}
 onChange={e=>{ setPassword(e.target.value); setError(''); }}
 onKeyDown={e=>e.key==='Enter'&&handleLogin()}
 placeholder="Enter your password" />
 <button onClick={()=>setShowPass(p=>!p)}
 style={{ position:'absolute', right:14, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', color:C.text2, cursor:'pointer', fontSize:16, padding:0 }}>
 {showPass?'':''}
 </button>
 </div>
 </div>

 {/* Forgot password */}
 <div style={{ textAlign:'right', marginBottom:24 }}>
 <button onClick={()=>setShowForgot(true)}
 style={{ background:'none', border:'none', color:C.accent, cursor:'pointer', fontSize:12, fontWeight:600, padding:0 }}>
 Forgot password?
 </button>
 </div>

 {/* Sign In button */}
 <button onClick={handleLogin} disabled={loading}
 style={{ width:'100%', padding:'14px', background:`linear-gradient(135deg,${C.accent},${C.accentDark})`, border:'none', borderRadius:10, color:'#fff', fontSize:15, fontWeight:700, cursor:'pointer', opacity:loading?.7:1, marginBottom:16, boxShadow:'0 4px 20px rgba(34,197,94,.3)' }}>
 {loading?'Signing in…':'Sign In →'}
 </button>

 {/* Quick login */}
 <div style={{ marginBottom:24 }}>
 <button onClick={()=>setShowQuick(p=>!p)}
 style={{ width:'100%', padding:'10px', background:'rgba(255,255,255,.04)', border:`1px solid ${C.border2}`, borderRadius:10, color:C.text2, cursor:'pointer', fontSize:12, fontWeight:600 }}>
 {showQuick?' Hide Quick Login':' Quick Login (Dev)'}
 </button>
 {showQuick && (
 <div style={{ marginTop:10, display:'grid', gridTemplateColumns:'1fr 1fr', gap:6 }}>
 {QUICK_LOGINS.map(q=>(
 <button key={q.email} onClick={()=>fillQuick(q)}
 style={{ padding:'8px 10px', background:`${q.color}15`, border:`1px solid ${q.color}33`, borderRadius:8, color:q.color, cursor:'pointer', fontSize:11, fontWeight:600, textAlign:'left' }}>
 {q.label}
 </button>
 ))}
 </div>
 )}
 </div>

 {/* Footer */}
 <div style={{ borderTop:`1px solid ${C.border}`, paddingTop:20, textAlign:'center' }}>
 <div style={{ fontSize:11, color:C.text3, marginBottom:4 }}>Botanix Resort Pvt. Ltd.</div>
 <div style={{ fontSize:11, color:C.text3 }}>GSTIN: 06AAGCB9754R1ZT · PAN: AAGCB9754R</div>
 <div style={{ fontSize:10, color:C.text3, marginTop:8 }}>Powered by Botanix ERP v2.0</div>
 </div>
 </div>
 </div>
 );
}
